import { req } from './Network';

// auth
export const LOGIN = (body) => {
  return req.post('/api/v1/auth/login', { id: body.id, password: body.password });
};

export const LOGOUT = (body) => {
  return req.post('/api/v1/auth/logout', { accountId: body.accountId });
};

// voucher
export const REGISTER_VOUCHER = (body) => {
  return req.post('/api/v1/vouchers/register', body);
};

// messages
export const FREE_TRIAL_VOUCHER_ALIMTALK_MESSAGE = (body) => {
  return req.post('/api/v1/messages/alimtalk/free-trial-vouchers', {
    brandName: body.brandName,
    phoneNumber: body.phoneNumber,
    usagePeriod: body.usagePeriod,
    applicationType: body.applicationType,
    code: body.code
  });
};

// influencers
export const INFLUENCER_INFO = (body) => {
  return req.get(`/api/v1/influencers/code/${body.code}`);
};

// advertisement
export const ADVERTISEMENT_INFO = (body) => {
  return req.get(`/api/v1/advertisements/code/${body.code}`);
};
